const text = (value) => String(value == null ? '' : value).trim();

const duplicateValue = (rows, selector) => {
  const seen = new Set();
  for (const row of rows || []) {
    const value = text(selector(row)).toLowerCase();
    if (!value) continue;
    if (seen.has(value)) return text(selector(row));
    seen.add(value);
  }
  return null;
};

export function validatePaymentMethodRows(rows) {
  if (!Array.isArray(rows) || rows.length === 0) return 'Please add at least one payment method.';
  for (let index = 0; index < rows.length; index += 1) {
    const row = rows[index] || {};
    if (!text(row.name)) return `Row ${index + 1}: Payment Method Name is required.`;
    if (row.percent === '' || row.percent == null || !Number.isFinite(Number(row.percent)) || Number(row.percent) < 0 || Number(row.percent) > 100) {
      return `Row ${index + 1}: Percentage must be a number from 0 to 100.`;
    }
  }
  const duplicate = duplicateValue(rows, (row) => row.name);
  return duplicate ? `Payment method "${duplicate}" is duplicated.` : null;
}

export function validateItemCategoryRows(rows) {
  if (!Array.isArray(rows) || rows.length === 0) return 'Please add at least one item category.';
  for (let index = 0; index < rows.length; index += 1) {
    const row = rows[index] || {};
    const start = Number(row.startingid);
    const increment = Number(row.incrementby);
    const end = Number(row.endingnumber);
    if (!text(row.categoryname)) return `Row ${index + 1}: Category Name is required.`;
    if (!text(row.categorycode)) return `Row ${index + 1}: Category Code is required.`;
    if (!Number.isInteger(start) || start <= 0) return `Row ${index + 1}: Starting From must be a positive whole number.`;
    if (!Number.isInteger(increment) || increment <= 0) return `Row ${index + 1}: Increment By must be a positive whole number.`;
    if (!Number.isInteger(end) || end < start) return `Row ${index + 1}: Ending Number must be a whole number greater than or equal to Starting From.`;
  }
  const duplicateName = duplicateValue(rows, (row) => row.categoryname);
  if (duplicateName) return `Category name "${duplicateName}" is duplicated.`;
  const duplicateCode = duplicateValue(rows, (row) => row.categorycode);
  return duplicateCode ? `Category code "${duplicateCode}" is duplicated.` : null;
}

export function validateItemNumericRows(rows) {
  const numericFields = [
    ['quantity', 'Quantity'], ['reserve', 'Reserve'], ['margin', 'Margin'],
    ['cost', 'Cost'], ['targetPrice', 'Target Price'],
  ];
  for (let index = 0; index < (rows || []).length; index += 1) {
    const row = rows[index] || {};
    for (const [key, label] of numericFields) {
      const value = row[key];
      if (value === '' || value == null) continue;
      if (!Number.isFinite(Number(value)) || Number(value) < 0) {
        return `Row ${index + 1}: ${label} must be a number greater than or equal to zero.`;
      }
    }
  }
  const duplicateName = duplicateValue(rows, (row) => row.itemname);
  return duplicateName ? `Item name "${duplicateName}" is duplicated in this submission.` : null;
}
